module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABTUlEQVQ4T2NkoBAwgvQHFJwX0FRhW8HCzKTPxMTIx/CfgQ3d3HuPPjPxcLJ8ExJiffXrJ8OU7iKdfpAasAHVM64vc7aWjcTlmCfPvzCI8DAxqMnzgpXcuv/py5Rld2y3TbO+ADYgven8Lm4eFjZWFkYLVmYmdn4eVhSzfv76y+BnLwEWu//0K4OIMCfDyh0Pp04qM8wBGwADXfNvPpAQZpeP9ZXHGTKXb39kePPxN8PqnY8XTq8xSsBqgLWhCMOpy+8wDOHmZGZQkOYmbIC7tQTDy7c/cLqCoAuCXGTAfkUHXBzMDF+//yHsAgMNAYYrtz9idYGOKj9hAygORFV5XoZNB56CXaCrws8Q6SUHdw1RsUCxCygyQEdVQP7F6294s5i5vijDlGW3MBNSad+lE0ZaQtycHKx/8Jnw5v13zqMX35bMbzDegpISycnZAOBaxRFghtspAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ztree/node.png
// module id = 5RLj
// module chunks = 1